<div class="filter-for-list">
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>
  <mat-slide-toggle class="sliderActiveList" (change)="reLoadList()" ngModel="activeProject" placement="right"
                    [ngbTooltip]="'PROJECT_ACTIVE_SLIDER_TOOLTIP' | translate">{{getActiveTextForSlider()}}
  </mat-slide-toggle>
  <div class="deviceTypeFilter" placement="right"
       [ngbTooltip]="'SUBSCRIPTIONS_TYPES' | translate">
    <mat-chip-list>
      <mat-chip
        *ngFor="let subscriptionType of subscriptionTypes index as i "
        (click)="filterListByModuleType(subscriptionType.value)"
        [ngClass]="{'selected' : subscriptionType.value === subscriptionTypeSelected}">
        {{subscriptionType.name | translate}}</mat-chip>
    </mat-chip-list>
  </div>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="matTableDataSource" matSort class="table-striped" style="width:100%">

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.id}}</td>
  </ng-container>

  <ng-container matColumnDef="level">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LEVEL'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <mat-chip-list>
        <mat-chip class="selected" matBadgePosition="below after" matBadgeColor="accent"
                  [matBadge]="project.level.level">
          {{project.level.name}}
        </mat-chip>
      </mat-chip-list>


    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
    <td mat-cell *matCellDef="let project">

      <mat-chip-list>
        <mat-chip class="selected">
          {{project.name}}
        </mat-chip>
      </mat-chip-list>

    </td>
  </ng-container>

  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'CODE'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <mat-chip-list>
        <mat-chip>
          {{project.code}}
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ADDRESS'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.address.place}} {{project.address.street}}
      {{project.address.zipcode}} {{project.address.city}} {{project.address.country}}
    </td>
  </ng-container>

  <ng-container matColumnDef="start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'START_DATE'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.start_date | date:'mediumDate': 'UTC'}}</td>
  </ng-container>

  <ng-container matColumnDef="end_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'END_DATE'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.end_date | date:'mediumDate': 'UTC'}}</td>
  </ng-container>

  <ng-container matColumnDef="subscription_maths_start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'START_SUBCRIPTION_DATE'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.subscription_maths_start_date}}</td>
  </ng-container>

  <ng-container matColumnDef="subscription_maths_end_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'END_SUBCRIPTION_DATE'|translate}}</th>
    <td mat-cell *matCellDef="let project"> {{project.subscription_maths_end_date}}</td>
  </ng-container>

  <ng-container matColumnDef="senceive_id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATE'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <fa-icon class="statusAbo"
               [ngClass]="{'red' : project.senceive_id === 0 , 'green' : project.senceive_id !== 0 }"
               [icon]="getIconStatus(project.senceive_id)"></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="senceive_action">
    <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <div class="d-flex">

        <div *ngIf="project.senceive_id === 0">
          <button type="button" class="btn list-tools"
                  (click)="openProjectSubscriptionModal(project)" placement="left"
                  [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
            <fa-icon [icon]="iconService.faPlus"></fa-icon>
          </button>
        </div>

        <div *ngIf="project.senceive_id !== 0">
          <button type="button" class="btn list-tools"
                  (click)="openProjectSubscriptionModal(project,project.senceive_id)" placement="left"
                  [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate">
            <fa-icon [icon]="iconService.faEdit"></fa-icon>
          </button>
          <button type="button" class="btn list-tools" style="background: red"
                  (click)="deleteSenceiveSubscription(project.senceive_id)"
                  placement="left"
                  [ngbTooltip]="'DELETE_ICON_TOOLTIP' | translate">
            <app-progressbar *ngIf="showSpinnerDelete"></app-progressbar>
            <fa-icon [pulse]="showSpinnerDelete" [icon]="iconService.faTrashAlt"></fa-icon>
          </button>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="csv_subscription_id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATE'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <fa-icon class="statusAbo"
               [ngClass]="{'red' : project.csv_subscription_id === 0 , 'green' : project.csv_subscription_id !== 0 }"
               [icon]="getIconStatus(project.csv_subscription_id)"></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="csv_subscription_action">
    <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <div class="d-flex">

        <div *ngIf="project.csv_subscription_id === 0">
          <button type="button" class="btn list-tools"
                  (click)="openCsvSubscriptionModal(project)" placement="left"
                  [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
            <fa-icon [icon]="iconService.faPlus"></fa-icon>
          </button>
        </div>

        <div *ngIf="project.csv_subscription_id !== 0">
          <button type="button" class="btn list-tools"
                  (click)="openCsvSubscriptionModal(project,project.csv_subscription_id)" placement="left"
                  [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate">
            <fa-icon [icon]="iconService.faEdit"></fa-icon>
          </button>
          <button type="button" class="btn list-tools" style="background: red"
                  (click)="deleteCsvSubscription(project.csv_subscription_id)"
                  placement="left"
                  [ngbTooltip]="'DELETE_ICON_TOOLTIP' | translate">
            <app-progressbar *ngIf="showSpinnerDelete"></app-progressbar>
            <fa-icon [pulse]="showSpinnerDelete" [icon]="iconService.faTrashAlt"></fa-icon>
          </button>
        </div>
      </div>
    </td>
  </ng-container>



  <ng-container matColumnDef="newsteo_id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATE'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <fa-icon class="statusAbo"
               [ngClass]="{'red' : project.newsteo_id === 0 , 'green' : project.newsteo_id !== 0 }"
               [icon]="getIconStatus(project.newsteo_id)"

      ></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="newsteo_action">
    <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <div class="d-flex">

        <div *ngIf="project.newsteo_id === 0">
          <button type="button" class="btn list-tools"
                  (click)="openNewsteoSubscriptionModal(project)" placement="left"
                  [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
            <fa-icon [icon]="iconService.faPlus"></fa-icon>
          </button>
        </div>

        <div *ngIf="project.newsteo_id !== 0">
          <button type="button" class="btn list-tools"
                  (click)="openNewsteoSubscriptionModal(project,project.newsteo_id)" placement="left"
                  [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate">
            <fa-icon [icon]="iconService.faEdit"></fa-icon>
          </button>
          <button type="button" class="btn list-tools" style="background: red"
                  (click)="deleteNewsteoSubscription(project.newsteo_id)"
                  placement="left"
                  [ngbTooltip]="'DELETE_ICON_TOOLTIP' | translate">
            <app-progressbar *ngIf="showSpinnerDelete"></app-progressbar>
            <fa-icon [pulse]="showSpinnerDelete" [icon]="iconService.faTrashAlt"></fa-icon>
          </button>
        </div>
      </div>
    </td>
  </ng-container>


  <ng-container matColumnDef="eventdyn_id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATE'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <fa-icon class="statusAbo"
               [ngClass]="{'red' : project.eventdyn_id === 0 , 'green' : project.eventdyn_id !== 0 }"
               [icon]="getIconStatus(project.eventdyn_id)"></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="eventdyn_action">
    <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <div class="d-flex">

        <div *ngIf="project.eventdyn_id=== 0">
          <button type="button" class="btn list-tools"
                  (click)="openEventdynSubscriptionModal(project)" placement="left"
                  [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
            <fa-icon [icon]="iconService.faPlus"></fa-icon>
          </button>
        </div>

        <div *ngIf="project.eventdyn_id !== 0">
          <button type="button" class="btn list-tools" style="background: red"
                  (click)="deleteEventdynSubscription(project.eventdyn_id)"
                  placement="left"
                  [ngbTooltip]="'DELETE_ICON_TOOLTIP' | translate">
            <app-progressbar *ngIf="showSpinnerDelete"></app-progressbar>
            <fa-icon [pulse]="showSpinnerDelete" [icon]="iconService.faTrashAlt"></fa-icon>
          </button>
        </div>
      </div>
    </td>
  </ng-container>


  <ng-container matColumnDef="corr_therm_id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATE'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <fa-icon class="statusAbo"
               [ngClass]="{'red' : project.corr_therm_id === 0 , 'orange' : project.corr_therm_id === 2 , 'blue' : project.corr_therm_id === 3 }"
               [pulse]="showSpinner || project.corr_therm_id === 3" [icon]="getIconStatus(project.corr_therm_id, true)"></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="corr_therm_action">
    <th mat-header-cell *matHeaderCellDef width="260px">{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let project">
      <div class="d-flex">
        &nbsp;&nbsp;<app-maths-naive-crud [projectName]="project.name" [projectState]="project.corr_therm_id"
                                          [projectId]="project.id" [mode]="CRUD_MODE.create"></app-maths-naive-crud>
        <app-maths-naive-crud [projectName]="project.name" [projectState]="project.corr_therm_id"
                              [projectId]="project.id" [mode]="CRUD_MODE.read"></app-maths-naive-crud>
        <app-maths-naive-crud [projectName]="project.name" [projectState]="project.corr_therm_id"
                              [projectId]="project.id" [mode]="CRUD_MODE.update"></app-maths-naive-crud>
        <button *ngIf="project.corr_therm_id !== 0" type="button" class="btn list-tools"
                style="background: darkgreen" placement="left"
                (click)="openExportCsvInterface(project)"
                [ngbTooltip]="'CSV_EXPORT_TOOLTIP' | translate">
          <fa-icon [icon]="iconService.faFileExcel"></fa-icon>
        </button>
        <app-maths-naive-crud [projectName]="project.name" [projectState]="project.corr_therm_id"
                              [projectId]="project.id" [mode]="CRUD_MODE.delete"></app-maths-naive-crud>
      </div>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>
